import { render, staticRenderFns } from "./Declare.vue?vue&type=template&id=7d9647bd&"
import script from "./Declare.vue?vue&type=script&lang=js&"
export * from "./Declare.vue?vue&type=script&lang=js&"
import style0 from "./Declare.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports